import axios from 'axios'

const API_URL = '/api/images/'

// Get Home images
const getHomeImages = async () => {
	const response = await axios.get(API_URL + 'getHomeImages')

	return response.data
}

const homeService = { getHomeImages }

export default homeService
